import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from "./config/API";

const PgWelcomePage = () => {
  const [pgList, setPgList] = useState([]);
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    location: "",
    pgType: "",
    pgUniqueId: "",
  });

  const [locations, setLocations] = useState([]);
  const [pgTypes, setPgTypes] = useState([]);
  const [pgIds, setPgIds] = useState([]);

  const setDropdownValues = (data) => {
    setLocations([
      ...new Set(data.map((item) => item.pgLocation).filter(Boolean)),
    ]);

    setPgTypes([...new Set(data.map((item) => item.pgType).filter(Boolean))]);

    setPgIds([...new Set(data.map((item) => item.pgUniqueId).filter(Boolean))]);
  };

  // Load all PG data

  const fetchAllPgData = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await axios.post(
        `${API.V2}/pgOwner/pgWelcomePage`,
        {
          location: null,
          pgType: null,
          pgUniqueId: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (response.data.statusCode === 200) {
        const data = response.data.data;

        setPgList(data);
        setDropdownValues(data);
      }
    } catch (error) {
      console.error("API Error", error);

      if (error.response?.status === 401) {
        alert("Session expired. Please login again.");

        localStorage.clear();
        navigate("/");
      }
    }
  };

  // Search with filters

  const fetchPgData = async () => {
    try {
      const response = await axios.post(
        "http://localhost:9777/pgOwner/pgWelcomePage",
        {
          location: filters.location || null,
          pgType: filters.pgType || null,
          pgUniqueId: filters.pgUniqueId || null,
        },
      );

      if (response.data.statusCode === 200) {
        setPgList(response.data.data);
      }
    } catch (error) {
      console.log("Search Error", error);
    }
  };

  useEffect(() => {
    fetchAllPgData();
  }, []);

  const handleChange = (e) => {
    setFilters({
      ...filters,

      [e.target.name]: e.target.value,
    });
  };

  const clearSearch = () => {
    setFilters({
      location: "",
      pgType: "",
      pgUniqueId: "",
    });

    fetchAllPgData();
  };

  const openAvailableBeds = (pg) => {
    navigate("/allAvailableBeds", {
      state: {
        adminemailId: pg.pgOwnerEmailId,
      },
    });
  };

  return (
    <>
      <style>{styles}</style>

      <div className="page-container">
        <div className="page-title">Welcome to SVK PG Hostel Management</div>

        <div className="header-section">
          <div className="filter-area">
            <select
              name="location"
              value={filters.location}
              onChange={handleChange}
            >
              <option value="">Select Location</option>

              {locations.map((location, index) => (
                <option key={index} value={location}>
                  {location}
                </option>
              ))}
            </select>

            <select
              name="pgType"
              value={filters.pgType}
              onChange={handleChange}
            >
              <option value="">Select PG Type</option>

              {pgTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>

            {/* <select
              name="pgUniqueId"
              value={filters.pgUniqueId}
              onChange={handleChange}
            >
              <option value="">Select PG</option>

              {pgIds.map((id, index) => (
                <option key={index} value={id}>
                  {id}
                </option>
              ))}
            </select> */}

            <button className="search-btn" onClick={fetchPgData}>
              Search
            </button>

            <button className="clear-btn" onClick={clearSearch}>
              Clear
            </button>
          </div>

          <button className="admin-btn" onClick={() => navigate("/")}>
            Are you PG Admin?
            <br />
            Login / Registration
          </button>
        </div>

        <div className="card-grid">
          {pgList.length > 0 ? (
            pgList.map((pg, index) => (
              <div
                className={`pg-card color-${index % 5}`}
                key={index}
                onClick={() => openAvailableBeds(pg)}
                style={{ cursor: "pointer", position: "relative" }}
              >
                <div className="pg-icon">
                  {pg.pgType === "Mens PG" && "👨"}

                  {pg.pgType === "Women's PG" && "👩"}

                  {pg.pgType === "Co_Living PG" && <>👨👩</>}
                </div>

                <h2>{pg.pgName}</h2>

                <div className="details">
                  <p>
                    <b>Location :</b> {pg.pgLocation || "N/A"}
                  </p>

                  <p>
                    <b>PG Type :</b> {pg.pgType || "N/A"}
                  </p>

                  <p>
                    <b>PG Unique ID :</b> {pg.pgUniqueId || "N/A"}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <h3>No PG Data Available</h3>
          )}
        </div>
      </div>
    </>
  );
};

export default PgWelcomePage;

const styles = `



.page-container{

padding:30px;

min-height:100vh;

background:#f4f6f9;

font-family:Arial;

}

.pg-icon {
  position: absolute;
  top: 15px;
  right: 18px;
  font-size: 32px;
}





.page-title{


text-align:center;

font-size:32px;

font-weight:bold;

color:white;

padding:25px;

border-radius:18px;

margin-bottom:25px;


background:
linear-gradient(
135deg,
#667eea,
#764ba2
);


box-shadow:0 5px 15px #aaa;


}





.header-section{


background:white;

padding:20px;

border-radius:15px;

display:flex;

justify-content:space-between;

align-items:center;

margin-bottom:30px;

box-shadow:0 5px 15px #ddd;


}





.filter-area{


display:flex;

gap:15px;

flex-wrap:wrap;


}





.filter-area select{


width:180px;

padding:12px;

border-radius:8px;

border:1px solid #ccc;


}





.search-btn,
.clear-btn{


padding:12px 25px;

border:none;

border-radius:8px;

color:white;

font-weight:bold;

cursor:pointer;


}





.search-btn{


background:
linear-gradient(
135deg,
#2193b0,
#6dd5ed
);


}





.clear-btn{


background:
linear-gradient(
135deg,
#757f9a,
#d7dde8
);


}





.admin-btn{


padding:15px 25px;

border:none;

border-radius:10px;

color:white;

font-weight:bold;

cursor:pointer;


background:
linear-gradient(
135deg,
#ff512f,
#dd2476
);


}





.card-grid{


display:grid;

grid-template-columns:
repeat(auto-fit,minmax(280px,1fr));

gap:25px;


}





.pg-card{


padding:25px;

border-radius:18px;

color:white;

min-height:180px;

box-shadow:0 6px 15px #bbb;

transition:.3s;


}





.pg-card:hover{


transform:translateY(-8px);


}





.pg-card h2{


font-size:22px;

border-bottom:1px solid #ffffff70;

padding-bottom:10px;


}




.details p{


margin:10px 0;

}





.color-0{


background:
linear-gradient(135deg,#667eea,#764ba2);

}



.color-1{


background:
linear-gradient(135deg,#11998e,#38ef7d);

}



.color-2{


background:
linear-gradient(135deg,#ff9966,#ff5e62);

}



.color-3{


background:
linear-gradient(135deg,#396afc,#2948ff);

}



.color-4{


background:
linear-gradient(135deg,#8360c3,#2ebf91);

}





@media(max-width:900px){


.header-section{

flex-direction:column;

gap:20px;

}


}


`;
